module.exports = __webpack_public_path__ + "img/B.c37a3f13.png";